import PropTypes from 'prop-types';
import React from 'react';

import * as S from './style';

const CardContent = ({ children, ...props }) => <S.Content {...props}>{children}</S.Content>;

CardContent.propTypes = PropTypes.shape({
  children: PropTypes.node
});

export { CardContent };
